<h2 mat-dialog-title id="medlem-stengtilgang-dialog-tittel">{{ "Steng tilgang for medlem"|translate }}</h2>
@if (trinn() == 'avsluttRoller') {
  <mat-dialog-content>
    <p>
      {{ '{navn} har følgende roller i gruppen. Vil du avslutte og sette sluttdato på dem?'|translate: {navn: medlem.navn} }}
    </p>
    <table class="aktiveRoller">
      <thead>
      <tr>
        <th></th>
        <th>{{'Avslutt rolle'|translate}}</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
        @for (rolle of aktiveRollerSkjema.controls; track rolle.value.rolleperiode.id) {
          <tr class="e2e-medlemsrolle">
            <td class="tittel e2e-tittel">{{ rolle.value.rolleperiode.tittel }}</td>
            <td class="avslutt">
              <mat-checkbox [formControl]="rolle.controls.avslutt" class="e2e-avslutt"></mat-checkbox>
            </td>
            <td class="sluttdato">
              <mat-form-field>
                <mat-label>{{ "Sluttdato" | translate }}</mat-label>
                <input matInput [min]="rolle.value.minSluttdato" [matDatepicker]="sluttdatoVelger" [formControl]="rolle.controls.sluttdato" class="e2e-sluttdato">
                <mat-datepicker-toggle matPrefix [for]="sluttdatoVelger"/>
                <mat-datepicker #sluttdatoVelger/>
                @if (rolle.controls.sluttdato.hasError('matDatepickerParse')) {
                  <mat-error data-testid="matDatepickerParse">{{ rolle.controls.sluttdato.errors | standardvalideringsfeil:'matDatepickerParse' }}</mat-error>
                }
                @if (rolle.controls.sluttdato.hasError('matDatepickerMin')) {
                  <mat-error data-testid="matDatepickerMin">{{ 'Sluttdata kan ikke være tidligere enn startdato ({startdato})'|translate: {startdato: rolle.value.minSluttdato|plaindate} }}</mat-error>
                }
              </mat-form-field>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="trinn.set('stengTilgang')" [disabled]="aktiveRollerSkjema.invalid" class="e2e-neste">{{ "Neste"|translate }}
    </button>
  </mat-dialog-actions>
}

@if (trinn() == 'stengTilgang') {
  <mat-dialog-content>
    <medlem-steng-tilgang-bekreftelse [medlem]="medlem" [gruppe]="gruppe"/>
    <!--eksponerer ikke lenger valgene oppdaterMoetemal / oppdaterFremtidigeMoete for bruker, se tidligere commiter-->
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
    @if (aktiveRollerSkjema.length > 0) {
      <button mat-button type="button" (click)="trinn.set('avsluttRoller')">{{ "Forrige"|translate }}</button>
    }
    <button mat-raised-button color="primary" type="button" (click)="steng()" [disabled]="lagrer()"
            [visSpinner]="lagrer()" spinnerTekst="{{'Stenger...'|translate}}" class="e2e-stengtilgang">
      {{ "Steng tilgang"|translate }}
    </button>
  </mat-dialog-actions>
}
